import { PlayCircleFilled } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
const recentContent = [
  {
    id: 101,
    title: "Mastering React.js in 2025 - What's New?",
    desc: "Learn about the latest features in React.js, including the new Server Components and more!",
    url: "https://youtube.com/shorts/b-X8aU42iLI?si=H5A5EG0XMEGqMo9f",
    thumbnail:
      "https://img.youtube.com/vi/b-X8aU42iLI/hqdefault.jpg",
  },
  {
    id: 102,
    title: "Pronttera Labs: Step-by-Step Onboarding Guide | 10-Minute Walkthrough",
    desc: "Welcome to Pronttera Labs' official onboarding tutorial! In this concise 10-minute video, we'll guide you through the essential steps to seamlessly integrate into our innovative ecosystem.",
    url: "https://www.youtube.com/watch?v=kzukZRnnYnc",
    thumbnail:
      "https://img.youtube.com/vi/kzukZRnnYnc/hqdefault.jpg",
  },
];
export default function RecentContent() {
  return (
    <div className="bg-slate-900">
      <section className="flex items-center justify-between flex-col md:flex-col px-4 md:px-32 section"  >
        <Typography.Title className="w-full !text-white" >Recent Content</Typography.Title>
        {recentContent.map((content) => (
          <div
            onClick={() => { window.open(content.url) }}
            key={content.id} className="transition hover:bg-slate-800  px-2 py-4 rounded-2xl !cursor-pointer grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="md:p-5">
              <Typography variant="p-card" className="text-slate-500">LATEST VIDEO</Typography>
              <Typography.Title level={3} className="!text-slate-200">{content.title}</Typography.Title>
              <Typography className="text-slate-400">{content.desc}</Typography>
            </div>
            <div className="md:p-5 relative">
              <div className="absolute top-0 left-0 w-full h-full bg-transparent flex justify-center items-center">
                <div
                  className="relative flex items-center justify-center w-10 h-10 bg-transparent text-white rounded-full shadow-md hover:bg-blue-600 active:bg-blue-700 transition duration-200 cursor-pointer"
                  // onClick={() => !isDisabled && showModal()}
                  role="button"
                >
                  <PlayCircleFilled className="text-5xl text-white" />
                </div>
              </div>
              <img src={`${content.thumbnail}`} alt="thumbnail" className="rounded-lg w-full h-full aspect-video object-cover" />
            </div>
          </div>
        ))}
      </section>
    </div>

  );
}
